export default "__VITE_ASSET__CvO9rxxX__"